import colors from 'vuetify/lib/util/colors';

let themes = {};
themes.green = {
  toolbar: {
    // logo: "https://capture672-public.s3-eu-west-1.amazonaws.com/capture672-logo.png",
    backgroundColor: "green",
    fontColor: "white",
    fontColorActive: "white",
    borderColorActive: "white",
    backgroundColorActive: "transparent",
    backgroundColorIcon: "green lighten-3"
  }
};

themes.blue = {
  toolbar: {
    // logo: "https://capture672-public.s3-eu-west-1.amazonaws.com/capture672-logo.png",
    backgroundColor: "blue",
    fontColor: "white",
    fontColorActive: "white",
    borderColorActive: "white",
    backgroundColorActive: "transparent",
    backgroundColorIcon: "blue lighten-3"
  }
};

themes.green = {
  toolbar: {
    // logo: "https://capture672-public.s3-eu-west-1.amazonaws.com/capture672-logo.png",
    backgroundColor: "green",
    fontColor: "white",
    fontColorActive: "white",
    borderColorActive: "white",
    backgroundColorActive: "transparent",
    backgroundColorIcon: "green lighten-3"
  }
};

themes.yellow = {
  toolbar: {
    // logo: "https://capture672-public.s3-eu-west-1.amazonaws.com/capture672-logo.png",
    backgroundColor: "yellow",
    fontColor: "#000",
    fontColorActive: "#000",
    borderColorActive: "#000",
    backgroundColorActive: "transparent",
    backgroundColorIcon: "yellow lighten-3"
  }
};

themes.whitePurple = {
  toolbar: {
    // logo: "https://capture672-public.s3-eu-west-1.amazonaws.com/capture672-logo.png",
    backgroundColor: "#fff",
    fontColor: "#263238",
    fontColorActive: "#000",
    borderColorActive: "#6A1B9A",
    backgroundColorActive: "transparent",
    backgroundColorIcon: "purple lighten-3"
  }
};

themes.lw365 = {
  toolbar: {
    // logo: "https://capture672-public.s3-eu-west-1.amazonaws.com/capture672-logo.png",
    backgroundColor: "#061551",
    fontColor: "#fff",
    fontColorActive: "#fff",
    borderColorActive: "#FCE512",
    backgroundColorActive: "transparent",
    backgroundColorIcon: "purple lighten-3"
  }
};

themes.default = themes.green;

let mainColors = ['blue', 'purple', 'orange','red', 'yellow', 'green',  'pink', 'brown', 'deepPurple', 'lightGreen', 'indigo', 'deepOrange',  'lightBlue', 'cyan', 'teal',  'lime',  'amber',   'blueGrey', 'grey']
for(let i = 0; i < mainColors.length; i++) {

}

let list = [
  {key: 'base', title: 'Default'},
  {key: 'lighten1', title: 'Lighten 1'},
  {key: 'lighten2', title: 'Lighten 2'},
  {key: 'lighten3', title: 'Lighten 3'},
  {key: 'lighten4', title: 'Lighten 4'},
  {key: 'lighten5', title: 'Lighten 5'},
  {key: 'darken1', title: 'Darken 1'},
  {key: 'darken2', title: 'Darken 2'},
  {key: 'darken3', title: 'Darken 3'},
  {key: 'darken4', title: 'Darken 4'},
  {key: 'accent1', title: 'Accent 1'},
  {key: 'accent2', title: 'Accent 2'},
  {key: 'accent3', title: 'Accent 3'},
  {key: 'accent4', title: 'Accent 4'}

];
console.log(colors);
let m = 'darken1';

let str = "";
for(let i = 0; i < mainColors.length; i++) {
  try {
    let c = colors[mainColors[i]][m];
    str += c + ",";

  } catch(err) {

  }
}
console.log(str);

export default themes;
